import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
} from 'react'
import Snackbar from '../components/snackbar'

// import { Container } from './styles'

type ISnackbarContextProps = {
  setIsShowing: (state: boolean) => void;
  setText: (state: string) => void;
  setType: (state: 'success' | 'error' | 'alert') => void;
}

type ISnackbarProviderProps = {
  children: ReactNode;
}

const SnackbarContext = createContext({} as ISnackbarContextProps)

const SnackbarProvider = ({ children }: ISnackbarProviderProps) => {
  const [text, setText] = useState('')
  const [isShowing, setIsShowing] = useState(false)
  const [type, setType] = useState<'success' | 'error' | 'alert'>('success')

  return (
    <SnackbarContext.Provider
      value={{
        setText,
        setIsShowing,
        setType,
      }}
    >
      {children}
      <Snackbar
        isShowing={isShowing}
        setIsShowing={setIsShowing}
        text={text}
        type={type}
      />
    </SnackbarContext.Provider>
  )
}

export const useSnackbar = () => {
  const context = useContext(SnackbarContext)

  if (!context) {
    throw new Error('useSnackbar must be used within a provider SnackbarProvider')
  }

  return context
}

export default SnackbarProvider
